import React, { useState, useEffect } from "react";
import Title from "../../Other/Title";
import { useLanguage } from "../../../i18n/LanguageContext";
import ServiceItem from "./components/ServiceItem";
import ProjectItem from "./components/ProjectItem";
import { motion, AnimatePresence } from "framer-motion";

const GithubProjects = () => {
  const { t } = useLanguage();
  const [activeFilter, setActiveFilter] = useState("all");
  const [isMobile, setIsMobile] = useState(false);
  
  const proects = [
    {
    id: 1,
      images: [
        "/projects/images/md/1.png",
        "/projects/images/md/2.png",
        "/projects/images/md/3.png",
      ],
      image: "/projects/profile/next.webp",
      title: "Markdown preview tool",
      link: "https://github.com/azateser/md-preview-tool",
      demoLink: "https://md-preview-tool.vercel.app",
      description: "Markdown preview application",
      category: "web",
    },
    {
      id: 1,
      images: [
        "/projects/images/fm/cover.png",
        "/projects/images/fm/1.png",
        "/projects/images/fm/2.png",
        "/projects/images/fm/3.png",
        "/projects/images/fm/4.png",
        "/projects/images/fm/5.png",
        "/projects/images/fm/6.png",
        "/projects/images/fm/7.png",
      ],
      image: "/projects/profile/frontend_mentor.png",
      title: "frontendMentor_Projects",
      link: "https://github.com/azateser/frontendMentor_Projects",
      description: "Frontend Mentor Challenge",
      category: "web",
    },
    {
      id: 2,
      images: [
        "/projects/images/reactjs/cover.png",
        "/projects/images/reactjs/1.png",
        "/projects/images/reactjs/2.png",
        "/projects/images/reactjs/3.png",
        "/projects/images/reactjs/4.png",
        "/projects/images/reactjs/5.png",
        "/projects/images/reactjs/6.png",
        "/projects/images/reactjs/7.png",
      ],
      image: "/projects/profile/react_js.webp",
      title: "15-React-Project",
      link: "https://github.com/azateser/15-React-Project",
      description: "ReactJS",
      category: "web",
    },
    {
      id: 3,
      images: [
        "/projects/images/expo/cover.png",
      ],
      image: "/projects/profile/react_native.webp",
      title: "expo_Projects",
      link: "https://github.com/azateser/expo_Projects",
      description: "React Native",
      category: "mobile",
    },
    {
      id: 4,
      images: [
        "/projects/images/dev/cover.png",
        "/projects/images/dev/1.webp",
        "/projects/images/dev/2.jpg",
        "/projects/images/dev/3.jpg",
        "/projects/images/dev/4.jpg",
        "/projects/images/dev/5.jpg",
        "/projects/images/dev/6.jpg",
        "/projects/images/dev/7.jpg",
        "/projects/images/dev/8.jpg",
        "/projects/images/dev/9.jpg",
        "/projects/images/dev/10.jpg",
        "/projects/images/dev/11.jpg",
        "/projects/images/dev/12.jpg",
      ],
      image: "/projects/profile/dev-chalanges.jpg",
      title: "devChallenges",
      link: "https://github.com/azateser/devChallenges",
      description: "devchallenges.io",
      category: "web",
    },
    {
      id: 5,
      images: [
        "/projects/images/write-game/cover.png",
        "/projects/images/write-game/1.png",
        "/projects/images/write-game/2.png",
        "/projects/images/write-game/3.png",
        "/projects/images/write-game/4.png",
      ],
      image: "/projects/profile/react_native.webp",
      title: "write-typing-game",
      link: "https://github.com/azateser/write-typing-game",
      demoLink: "https://azateser.github.io/write-typing-game/build/index.html",
      description: "React JS",
      category: "web",
    },
    {
      id: 6,
      images: [
        "/projects/images/fiverr/cover.png",
        "/projects/images/fiverr/1.png",
        "/projects/images/fiverr/2.png",
        "/projects/images/fiverr/3.png",
        "/projects/images/fiverr/4.png",
        "/projects/images/fiverr/5.png",
        "/projects/images/fiverr/6.png",
      ],
      image: "/projects/profile/react_js.webp",
      title: "fiverr-ui-clone",
      link: "https://github.com/azateser/fiverr-ui-clone",
      demoLink: "https://azateser.github.io/fiverr-ui-clone/dist/",
      description: "React JS",
      category: "web",
    },
  ];

  const filteredProjects = activeFilter === "all" 
    ? proects 
    : proects.filter(project => project.category === activeFilter);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  // Check if mobile on mount and when window resizes
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <div className="font-inter mt-80 md:mt-80 z-20" id="projects">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ margin: "-50px" }}
        className="mb-0 md:mb-0"
      >
        <Title title={isMobile ? t.github.titleShort : t.github.title} />
      </motion.div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ margin: "-50px" }}
        className="flex flex-wrap items-center gap-2 md:gap-4 justify-center -mt-2 md:-mt-80 px-4"
      >
        <motion.div 
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleFilterChange("all")}
          className={`cursor-pointer transition-all duration-300 ${activeFilter === "all" ? "scale-105" : ""}`}
        >
          <ServiceItem title={t.github.all} />
        </motion.div>
        <motion.div 
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleFilterChange("web")}
          className={`cursor-pointer transition-all duration-300 ${activeFilter === "web" ? "scale-105" : ""}`}
        >
          <ServiceItem title={t.github.web} />
        </motion.div>
        <motion.div 
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleFilterChange("mobile")}
          className={`cursor-pointer transition-all duration-300 ${activeFilter === "mobile" ? "scale-105" : ""}`}
        >
          <ServiceItem title={t.github.mobile} />
        </motion.div>
      </motion.div>
      
      <motion.div 
        className="grid grid-cols-1 gap-3 md:gap-6 lg:grid-cols-3 md:grid-cols-2 justify-center max-w-default m-auto xl:px-0 px-4 mt-3 md:mt-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ margin: "-50px" }}
        transition={{ staggerChildren: 0.15 }}
      >
        <AnimatePresence mode="wait">
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.95 }}
              viewport={{ margin: "-50px" }}
              transition={{ 
                duration: 0.5,
                delay: index * 0.1,
                type: "spring",
                stiffness: 50,
                damping: 8
              }}
              whileHover={{ 
                y: -10, 
                transition: { 
                  type: "spring", 
                  stiffness: 300, 
                  damping: 15 
                }
              }}
              className="relative"
              layout
            >
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/0 via-indigo-500/0 to-purple-500/0 group-hover:from-indigo-500/5 group-hover:via-indigo-500/5 group-hover:to-purple-500/0 rounded-lg -z-10"></div>
              <ProjectItem
                images={project.images}
                title={project.title}
                description={project.description}
                profile={project.image}
                link={project.link}
                demoLink={project.demoLink}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
      
      {filteredProjects.length === 0 && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center text-gray-400 mt-12"
        >
          No projects found in this category.
        </motion.div>
      )}
    </div>
  );
};

export default GithubProjects;
